import Swiper, {Lazy, Pagination} from "swiper"

const selectSwiper = {

    init: () => {

        var swiper = new Swiper(".select-swiper", {
            modules: [ Pagination, Lazy ],
            watchOverflow: true,
            spaceBetween: 20,
            centeredSlides: true,
            slidesPerView: 'auto',
            resizeObserver: true,
            a11y: true,
            grabCursor: true,
            preloadImages: false,
            lazy: {
                loadPrevNext: true
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            breakpoints: {
                1280 : {
                    centeredSlides: false
                },
            }
        });


    }
}

export default selectSwiper;
